import React from 'react'
import Typography from '@mui/material/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { reExportedColors } from './index'

const useStyles = makeStyles((theme, props) => ({
  root: {
    color: props => props.disabled ? theme.palette.secondary.main : theme.palette.primary.main,
    fontFamily: props => `${[
      'h1','h2','h4','fieldLabelProximity'
    ].includes(props.type) ? props.selectedFontStack : 'Lato, sans-serif'}`,
    lineHeight: 1
  },
  detailName: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '22px',
    fontWeight: 'bold'
  },
  detailInfoHead: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Roboto, sans-serif',
    fontSize: 13,
    padding: '8px 0'
  },
  detailInfoHeadAcc: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Roboto, sans-serif',
    fontSize: 13,
    marginBottom: '4px'
  },
  detailInfoHeadAccIcon: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Roboto, sans-serif',
    fontSize: 13
  },
  detailInfoHeadLinks: {
    color: reExportedColors.LINK, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    cursor: 'pointer',
    fontFamily: 'Roboto, sans-serif',
    fontSize: 13,
    textDecoration: 'underline'
  },
  detailNameDetailsHeader: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Roboto, sans-serif',
    fontSize: 15,
    fontWeight: '500',
    marginBottom: '4px',
    '& span': {
      fontWeight: 300,

      '&.requiredAsterisk': {
        color: reExportedColors.RED
      }
    }
  },
  detailNameDetailsText: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Roboto, sans-serif',
    fontSize: 13,
    fontWeight: '400',
    marginBottom: '4px'
  },
  fieldLabel: {
    fontSize: '15px',
    fontWeight: 700,

    '& span': {
      fontWeight: 300,

      '&.requiredAsterisk': {
        color: reExportedColors.RED ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
      }
    }
  },
  locationHeader: {
    color: reExportedColors.WHITE, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontSize: 13,
    lineHeight: 'normal'
  },
  locationHeaderLabel: {
    color: reExportedColors.WHITE, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 'normal',
    marginRight: 3
  },
  logoutText: {
    fontFamily: 'Lato, sans-serif',
    fontSize: 14,
    fontWeight: '600'
  },
  locationHeaderName: {
    color: reExportedColors.WHITE, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Lato, sans-serif',
    fontSize: 16,
    lineHeight: 'normal'
  },
  locationViewHeader: {
    color: reExportedColors.TEXT_BOLD, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Lato, sans-serif',
    fontSize: '18px',
    fontWeight: 'bold',
    letterSpacing: '0px',
    marginBottom: '4px',
    textAlign: 'left'
  },
  locationViewText: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Roboto, sans-serif',
    fontSize: '13px',
    fontWeight: 400,
    letterSpacing: '0px',
    textAlign: 'left'
  },
  locationViewText2: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    cursor: 'pointer',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '13px',
    fontWeight: 400,
    letterSpacing: '0px',
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '200px'
  },
  menuItem: {
    fontFamily: 'Lato, sans-serif',
    fontSize: 14,
    fontWeight: '600'
  },
  pCDetails: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Roboto, sans-serif',
    fontSize: 11
  },
  pCName: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Roboto, sans-serif',
    fontSize: 11,
    fontWeight: 'bold'
  },
  pTBM: {
    color: reExportedColors.DARK_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Roboto, sans-serif',
    fontSize: 13
  },
  pTClient: {
    cursor: 'pointer',
    float: 'left',
    fontFamily: 'Lato, sans-serif',
    fontSize: 18,
    fontWeight: 'bold'
  },
  pTClientAd: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 15,
    fontWeight: 500
  },
  resizedMenuItem: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Lato, sans-serif',
    fontSize: 11,
    fontWeight: '500'
  },
  searchResultMain: {
    fontSize: "1rem",
    fontWeight: 700,
    textAlign: 'left',
    fontFamily: 'Lato, sans-serif',
    color: "#4B4B4B !important",
    lineHeight: "18px",
    display: "inline-block",
  },
  searchResultSub: {
    fontSize: "1rem",
    fontWeight: 400,
    textAlign: 'left',
    fontFamily: 'Lato, sans-serif',
    color: "#888888 !important",
    lineHeight: "18px",
    display: "inline-block",
  },
  searchResultquery: {
    alignItems: 'center',
    color: reExportedColors.DARK_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    display: 'flex',
    fontSize: 11,
    justifyContent: 'flex-start',
    paddingTop: 4,
    textAlign: 'left'
  },
  subHeading: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Roboto, sans-serif',
    fontSize: 18,
    fontWeight: '500'
  },
  tabHeader: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Lato, sans-serif',
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 'normal',
    textDecoration: 'none',
    textTransform: 'capitalize'
  },
  terms: {
    color: reExportedColors.TERM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    font: 'normal normal normal 12px/15px Roboto',
    fontSize: 9,
    lineHeight: 1.5,
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word'
  },
  warnMessage: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Roboto, sans-serif',
    fontSize: 13,
    fontWeight: 'normal'
  },
  WelcomeMessage: {
    display: 'block',
    fontFamily: 'Lato, sans-serif',
    fontSize: 18,
    lineHeight: 'normal',
    marginTop: 12
  },
  welcomeText: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    font: 'normal normal normal 13px/18px Roboto, sans-serif',
    fontSize: '13px',
    letterSpacing: '0px',
    textAlign: 'justify'
  },
  addBuildingNameCta: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    font: 'normal normal normal 13px/18px Roboto, sans-serif',
    fontSize: '12px',
    letterSpacing: '0px',
    textDecoration: 'underline',
    cursor: 'pointer',

    '&:hover': {
      opacity: 0.7
    }
  },
  collapsibleHeadName: {
    fontSize: '18px',
    fontWeight: 'bold',
    fontFamily: 'Lato',
    color: reExportedColors.TEXT ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  collapsibleTabLabel: {
    textDecoration: 'none',
    fontFamily: 'Lato, sans-serif',
    fontWeight: 'bold',
    fontSize: '16px',
    whiteSpace: 'nowrap'
  },
  adminDashboardPageHeader: {
    flexGrow: 2,
    fontSize: '22px',
    fontWeight: 'bold',
    fontFamily: 'Lato',
    color: reExportedColors.TEXT ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  adminDashboardTabHeader: {
    fontSize: '22px',
    fontWeight: 'bold',
    fontFamily: 'Lato',
    color: reExportedColors.TEXT ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  smartFormInstruction: {
    '& span': {
      fontWeight: 'bold'
    }
  },
  serviceTypeName: {
    cursor: 'pointer',
    fontSize: '18px',
    fontFamily: 'Lato, sans-serif',
    fontWeight: 'bold'
  },
  noService: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Roboto, sans-serif',
    fontSize: 14
  },
  contactTypeName: {
    cursor: 'pointer',
    fontSize: '18px',
    fontFamily: 'Lato, sans-serif',
    fontWeight: 'bold'
  },
  serviceSetTabHeading: {
    fontSize: '18px',
    fontFamily: 'Lato, sans-serif',
    fontWeight: 'bold'
  },
  tabHeadingSecondary: {
    fontSize: '22px',
    fontFamily: 'Lato, sans-serif',
    '& span': {
      fontWeight: 'bold'
    }
  },
  dataRecordStatusTabHeader: {
    fontSize: '22px',
    fontFamily: 'Lato, sans-serif',
    fontWeight: 'bold'
  },
  textFieldError: {
    color: reExportedColors.ERROR_RED, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontSize: '0.75rem',
    marginTop: '3px',
    textAlign: 'left',
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    lineHeight: 1.66,
    letterSpacing: '0.03333em'
  },
  selectOwnerModalHeader: {
    color: reExportedColors.TEXT_BOLD, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Lato, sans-serif',
    fontSize: '20px',
    fontWeight: 'bold',
    letterSpacing: '0px'
  },
  serviceTabOptionItemLabel: {
    color: reExportedColors.TEXT_BOLD, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Lato, sans-serif',
    fontSize: '18px',
    fontWeight: 'bold'
  },
  dataExportConfirmation: {
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Lato, sans-serif',
    fontSize: '16px',
    '& span': {
      color: reExportedColors.TEXT_BOLD, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
      fontWeight: 'bold'
    }
  },
  helperText: {
    color: reExportedColors.DARK_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Lato, sans-serif',
    fontSize: '14px'
  },
  fileUploadHelper: {
    color: reExportedColors.MEDIUM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    '& span': {
      color: reExportedColors.BLUE,
      textDecoration: 'underline'
    }
  },
  selectedFileHeader: {
    fontSize: '16px',
    fontWeight: 'bold'
  },
  errorLogHeader: {
    color: reExportedColors.DARK_GREY ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  errorText: {
    fontWeight: 'bold'
  },
  learnFormatHelper: {
    '& a': {
      textDecoration: 'underline'
    }
  },
  bulkImportRuleHeader1: {
    color: reExportedColors.BLUE, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Lato, sans-serif',
    fontSize: '28px'
  },
  bulkImportRuleHeader2: {
    color: reExportedColors.BLUE, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Lato, sans-serif',
    fontSize: '20px'
  },
  bulkImportRuleHeader3: {
    color: reExportedColors.DARK_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Lato, sans-serif',
    fontSize: '17.3px',
    fontWeight: 'bold'
  },
  bulkImportRuleHeader4: {
    color: reExportedColors.DARK_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontFamily: 'Lato, sans-serif',
    fontSize: '16px',
    fontWeight: 'bold'
  },
  bulkImportRuleBody: {
    '& a': {
      textDecoration: 'underline'
    }
  },
  widgetDonutChartLabel: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '12px',
    color: reExportedColors.TEXT ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  widgetDonutChartPercentage: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '12px',
    color: reExportedColors.TEXT ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  widgetDonutChartCounter: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '14px',
    color: reExportedColors.TEXT ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  widgetsHeader: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '16px',
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontWeight: 'bold',

    '& span': {
      fontSize: '12px',
      fontWeight: '400'
    }
  },
  widgetsHeaderDate: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '12px',
    color: reExportedColors.TEXT ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  dashboardTodayHeader: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '22px',
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontWeight: 'bold'
  },
  dashboardTodayHeaderDate: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '18px',
    color: reExportedColors.TEXT ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  latestFeedbackComment: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '12px',
    color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontWeight: '800'
  },
  latestSatisfactionScoreHeading: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '18px',
    fontWeight: '600'
  },
  dashboardDonutCharDate: {
    fontSize: '11px',
    color: reExportedColors.MEDIUM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    lineHeight: 1
  },
  latestSatisfactionScoreSubHeading: {
    fontSize: '14px',
    color: reExportedColors.MEDIUM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    '& span': {
      textDecoration: 'underline'
    }
  },
  latestSatisfactionScoreBody: {
    fontSize: '11px',
    color: reExportedColors.MEDIUM_GREY ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  dataVisibilitySwitchLabel: {
    fontSize: '13px',
    fontWeight: 400,
    color: reExportedColors.MEDIUM_GREY ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  pageCount: {
    fontSize: '12px',
    fontWeight: 'bold'
  },
  h1: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '20px',
    fontWeight: '600',
    color: theme.palette.tertiary.main,
    lineHeight: 1.2,
    letterSpacing: 0.2
  },
  h2: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '20px',
    fontWeight: '500',
    color: theme.palette.tertiary.main
  },
  h3: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '14px',
    fontWeight: '700'
  },
  h4: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '14px',
    fontWeight: '500'
  },
  h5: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '10px',
    fontWeight: '400'
  },
  h6: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '9px',
    fontWeight: '450'
  },
  h8: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '20px',
    fontWeight: '700'
  },
  h9: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '14px',
    fontWeight: '600'
  },
  h10: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '20px',
    fontWeight: '600'
  },
  p: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '14px',
    fontWeight: '400'
  },
  fieldLabelProximity: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '10px',
    fontWeight: '500',
    color: theme.palette.tertiary.main
  },
  oneLiner: {
    fontFamily: 'Raleway, sans-serif',
    fontSize: 12,
    fontWeight: '400',
    fontStyle: 'italic',
    color: reExportedColors.BLACK ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  validationError: {
    fontSize: '12px',
    color: reExportedColors.ERROR_RED ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  accountAvatar: {
    fontSize: 30,
    fontWeight: '600'
  }
}))

export default function Text ({ style, type, children, className, disabled, title }) {
  const textTitle = title ?? '';
  const fontStyleSelect = localStorage.getItem('fontStyleSelect')
  let selectedFontStack = "'Montserrat', sans-serif"
  switch (fontStyleSelect) {
    case 'Roboto':
      selectedFontStack = "'Roboto', sans-serif"
      break
    case 'Open Sans':
      selectedFontStack = "'Open Sans', sans-serif"
      break
    case 'Segoe UI':
      selectedFontStack = "'Segoe UI', sans-serif"
      break
    default:
      selectedFontStack = "'Montserrat', sans-serif"
  }
  const classes = useStyles({ selectedFontStack, type, disabled})
  return (
    <Typography
      component={'span'}
      className={`${classes.root} ${classes[type]} ${className}`}
      style={style}
      title={textTitle}
    >
      {children}
    </Typography>
  )
}
